import * as actionTypes from 'src/old/actions';

const initialState = {
  fileFeedback: null,
  fileUploadLoading: false
};

const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FILE_FEEDBACK: {
      return {
        ...state,
        fileFeedback: action.fileFeedback
      };
    }
    case actionTypes.UNKNOWN_ERROR: {
      return {
        ...state,
        fileFeedback: 'UNKNOWN'
      };
    }

    case actionTypes.WRONG_FILE_FORMAT: {
      return {
        ...state,
        fileFeedback: 'WRONG_FILE_FORMAT'
      };
    }
    case actionTypes.FILE_LOADING_START: {
      return {
        ...state,
        fileUploadLoading: true
      };
    }
    case actionTypes.FILE_LOADING_END: {
      return {
        ...state,
        fileUploadLoading: false
      };
    }
    case actionTypes.CLEAR_FILE_FEEDBACK: {
      return {
        ...initialState
      };
    }
    default: {
      return state;
    }
  }
};

export default fileReducer;
